import React, { useContext } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";

const ButtonSubmitFormikPermission = ({ name, permission, disabled }) => {
  const { isAllowed } = useContext(AuthContext);

  return isAllowed(permission) ? (
    <Button variant="primary" type="submit" className="mr-3" disabled={disabled}>
      {name}
    </Button>
  ) : (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Acesso negado</Tooltip>}>
      <span className="d-inline-block">
        <Button style={{ pointerEvents: "none" }} variant="primary" type="submit" className="mr-3" disabled>
          {name}
        </Button>
      </span>
    </OverlayTrigger>
  );
};

export default ButtonSubmitFormikPermission;
